let Promise = require('bluebird');
let Vue = require('vue');

module.exports = () => new Promise((resolve, reject) => {
    Vue.component("menu_events_count", {
        template: `
            <div class="">
                <div class="dashboard-stat blue-hoki">
                    <div class="visual">
                        <i class="icon-calendar"></i>
                    </div>
                    <div class="details">
                        <div class="number">{{data.info.count}}</div>
                        <div class="desc">Atividades</div>
                    </div>
                    <a class="more" href="{{ '/calendar' | url }}">
                        ver agenda
                        <i class="m-icon-swapright m-icon-white"></i>
                    </a>
                </div>
            </div>
        `,
        props: ["alias", "data"]
    });

    resolve();
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/menu_events_count.js